import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Text = styled.div.attrs(() => ({
    className: "l-base-text",
}))`
    margin: ${theme.space[3]}px 0;
    color: ${theme.colors.platinumDark};
    @media ${getBreakpoint("up", "lg")} {
        max-width: 222px;
    }
`;
